import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
    selector: 'aw-colour-picker',
    templateUrl: './colour-picker.component.html',
    styleUrls: ['./colour-picker.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColourPickerComponent),
            multi: true
        }
    ],
    imports: [FormsModule]
})
export class ColourPickerComponent implements OnInit, ControlValueAccessor {
  pickedColour;
  hexColour;
  modelOptions = {
    standalone: true
  };
  constructor() { }

  propagateChange = (_: any) => {
  };

  ngOnInit() {
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.hexColour = obj;
    this.pickedColour = obj;
  }
  
  onChange($event) {
    this.writeValue($event);
    this.propagateChange($event);
  }

}
